/**
 * Symbol-format conversion (U1 / KTD1b) — the ONE place the base/quote delimiter swap lives.
 *
 * The UI holds pairs in the store's native SLASH form (BTC/USD); the requests the hosts accept use
 * DASH form (BTC-USD); persisted rows have been seen in UNDERSCORE form. Both helpers normalize the
 * separator on input (treat `/`, `-`, `_` as equivalent) because `loadSymbols()` in App.svelte
 * defensively checks both BTC-USD and BTC/USD — the API's delimiter isn't guaranteed at runtime.
 *
 * Moved here from `SymbolMultiSelect.svelte`'s module script (TASK-20260823) so DOM-free `lib/`
 * modules can share the seam under Vitest; the picker re-exports these, so its importers are
 * unchanged.
 */

/** Replace the FIRST base/quote separator with the target delimiter; leave everything else untouched. */
function swapSeparator(pair, target) {
  if (typeof pair !== 'string') return pair;
  return pair.replace(/[/\-_]/, target);
}

/** BTC/USD → BTC-USD (idempotent on already-dash input). */
export function toRequestSymbol(pair) {
  return swapSeparator(pair, '-');
}

/** BTC-USD → BTC/USD (idempotent on already-slash input). */
export function fromRequestSymbol(pair) {
  return swapSeparator(pair, '/');
}
